<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class ChartModal extends Vue {
        @Prop()
        name;
        @Prop()
        title;
        @Prop()
        width;
        @Prop()
        position;

        left = 0;
        top = 0;
        box = null;
        mouseDown(e: MouseEvent) {
            let x = e.clientX;
            let y = e.clientY;
            let changeLeft = this.left;
            let changeTop = this.top;
            const boxWidth = this.box.clientWidth;
            const boxHeight = this.box.clientHeight;
            const maxLeft = this.box.parentElement.clientWidth - boxWidth;
            const maxTop = this.box.parentElement.clientHeight - boxHeight;
            document.onmousemove = (e) => {
                let tempLeft = changeLeft + e.clientX - x;
                let tempTop = changeTop + e.clientY - y;
                tempLeft = tempLeft < 0 ? 0 : tempLeft > maxLeft ? maxLeft : tempLeft;
                tempTop = tempTop < 0 ? 0 : tempTop > maxTop ? maxTop : tempTop;
                this.left = tempLeft;
                this.top = tempTop;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
        handleClose() {
            this.$emit("closeEvent");
        }
        mounted() {
            this.left = this.position.left;
            this.top = this.position.top;
            this.box = this.$refs.box;
        }
    }
</script>

<template>
    <div class="editemodal" ref="box" :style="{ top: top + 'px', left: left + 'px', width: width + 'px' }">
        <div class="title-bar" @mousedown="mouseDown">
            <div class="title-text">{{ title }}</div>
            <iconSymbol class="title-icon" name="echart-modal-close" @click.native="handleClose" />
        </div>
        <div>
            <slot />
        </div>
    </div>
</template>

<style lang="stylus" scoped>
    html.dark
        .editemodal
            box-shadow $box-shadow

    .editemodal
        position absolute
        left 0
        top 0
        width 100px
        padding 4px
        background var(--bg-color-echart-edit-modal);
        z-index 999
        border-radius 8px
        &.active
            z-index 99999
        .title-bar
            height 24px
            display flex
            justify-content space-between
            align-items center
            margin-bottom 4px
            cursor move
            .title-text
                height 24px
                padding 4px
                font-size 12px
                color #fff
            .title-icon
                width 24px
                height 24px
                color #fff
                cursor pointer
</style>
